import React, {
  ReactNode, FC, useEffect, useRef
} from 'react';
import classNames from 'classnames';
import screenOrientation from './screenOrientation.svg';
import styles from './mainLayoutComponent.module.css';

type PropsType = {
  AsideLeft?: ReactNode;
  Content?: ReactNode;
  AsideRight?: ReactNode;
};

const MainLayoutComponent: FC<PropsType> = ({ AsideLeft, Content, AsideRight }) => {
  const refAdTop = useRef<HTMLDivElement>(null);
  const refAdLeft = useRef<HTMLDivElement>(null);
  const refAdRight = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (refAdTop) {
      // @ts-ignore
      window.yaContextCb.push(() => {
        // @ts-ignore
        Ya.Context.AdvManager.render({
          blockId: 'R-A-3642064-1',
          renderTo: 'yandex_rtb_R-A-3642064-1'
        });
      });
    }
  }, [refAdTop]);

  useEffect(() => {
    if (refAdLeft) {
      // @ts-ignore
      window.yaContextCb.push(() => {
        // @ts-ignore
        Ya.Context.AdvManager.render({
          blockId: 'R-A-3642064-4',
          renderTo: 'yandex_rtb_R-A-3642064-4'
        });
      });
    }
  }, [refAdLeft]);

  useEffect(() => {
    if (refAdRight) {
      // @ts-ignore
      window.yaContextCb.push(() => {
        // @ts-ignore
        Ya.Context.AdvManager.render({
          blockId: 'R-A-3642064-5',
          renderTo: 'yandex_rtb_R-A-3642064-5'
        });
      });
    }
  }, [refAdRight]);

  return (
        <>
            <div ref={refAdTop} id="yandex_rtb_R-A-3642064-1" className="mt-20" />
            <div className={styles.container}>
                <div
                    ref={refAdLeft}
                    id="yandex_rtb_R-A-3642064-4"
                    className={classNames('sticky top-80 mr-10', styles.asideAd)}
                    style={{ width: '160px', height: '600px' }}
                />
                {AsideLeft}
                {Content}
                {AsideRight}
                <div
                    ref={refAdRight}
                    id="yandex_rtb_R-A-3642064-5"
                    className={classNames('sticky top-80 ml-10', styles.asideAd)}
                    style={{ width: '160px', height: '600px' }}
                />
            </div>
            <div className={styles.containerOrientation}>
                <img src={screenOrientation} alt="" />
                <br />
                <div>Мы не поддерживаем горизонтальную ориентацию экрана.<br />Переверните устройство!</div>
            </div>
        </>
  );
};

export default MainLayoutComponent;
